import { AfterViewInit, Component, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { extend, isString, set } from "lodash-es";
import { WmsTreeComponent } from "@wms/components";
import { MarkupManagerService } from "@wms/core";
import { PageWorkspaceComponent } from "@wms/workspace";
import { EventManagerService } from "@wms/app";
import {AppManagerService, WidgetPropertiesProvider} from "@wms/design-container";
import { Subscription } from "rxjs";
import {runtimeEventManager} from "@wm/core";
import { PageStructureService } from '../services/page-structure.service';
@Component({
  selector: 'wms-page-structure',
  standalone: true,
  imports: [CommonModule, WmsTreeComponent],
  templateUrl: './page-structure.component.html',
  styleUrls: ['./page-structure.component.less']
})
export class PageStructureComponent implements OnInit, AfterViewInit, OnDestroy {
  public registerDestroyListener = new Subscription();
  private markupManager: MarkupManagerService;
  private pageWsContent: JQuery<HTMLElement>;
  private pageWorkspaceComp: PageWorkspaceComponent;
  private widgetProperties: WidgetPropertiesProvider;

  level: number;
  parentWidgetId: any;
  activeElement: any;
  muteTreeChanges = true;
  hasPendingChanges: any;
  selectedNode: any;
  pageStructureNodes:any = [];
  activeTabName: string = 'DESIGN';
  private eventManager: EventManagerService;
  private pageStructureService: PageStructureService

  constructor() {
    let elRef = inject(ElementRef);
    this.pageWsContent = $(elRef.nativeElement);
    this.markupManager = inject(MarkupManagerService);
    this.pageWorkspaceComp = inject(PageWorkspaceComponent);
    this.eventManager = inject(EventManagerService);
    const appManager = inject(AppManagerService);
    this.widgetProperties = inject(WidgetPropertiesProvider);
    this.pageStructureService= inject(PageStructureService)
    this.registerDestroyListener.add(this.eventManager.pageRenderedObservable().subscribe((response) => {
      this.pageStructureNodes = this.buildTreeFromMarkup(this.markupManager.getMarkup(),[]);
    }));
    this.registerDestroyListener.add(runtimeEventManager.on('widget-name').subscribe((name: string) => {
      this.constructTree();
    }));
    this.registerDestroyListener.add(runtimeEventManager.on('update-pagestructure').subscribe(() => {
      this.constructTree();
    }));
    this.eventManager.canvasMarkupDirtyObservable().subscribe(() => {
      this.constructTree();
    });

    this.registerDestroyListener.add(this.eventManager.editorCursorChangeEventObservable().subscribe((widgetName) => {
      const widgetId =  this.pageWsContent.find(`[data-nodename="${widgetName}"]`).attr('widgetid');
      if(widgetId){
         this.selectWidget({widgetId: widgetId}, false);
      }else{
         this.resetActiveElement();
         this.selectedNode = null
      }
    }));

    this.registerDestroyListener.add(this.eventManager.changeInActiveTabAsObservable().subscribe((data) => {
      this.activeTabName = data
     }))
  }

  ngOnInit(): void {
    this.registerDestroyListener.add(this.eventManager.canvasUpdateObservable().subscribe((data: any)=>{
      this.canvasUpdated(data);
    }));
    this.registerDestroyListener.add(this.eventManager.updatePageStructureObservable().subscribe((data: any)=>{
      this.constructTree();
    }));
  }

  ngAfterViewInit() {
    this.pageWsContent = this.pageWsContent.find('[class=' + 'treecontent' + ']');
  }

  constructTree(element?:any, force?:boolean){
    this.hasPendingChanges = true;
    this.pageStructureNodes = this.buildTreeFromMarkup(this.markupManager.getMarkup());
    this.hasPendingChanges = false;

    this.setActiveElement();
  }

  setActiveElement() {
    let activeSelector;
    let activeMarkupEl = this.markupManager.getActiveMarkupEl();

    if (!this.activeElement?.length && activeMarkupEl && activeMarkupEl.length) {
      this.resetActiveElement();

      activeSelector = {
        'eventType': 'SELECT',
        'widgetId': activeMarkupEl.attr('widget-id')
      };
      this.selectWidget(activeSelector);
    }else{
      const widgetId = activeMarkupEl?.attr('widget-id')
      if (widgetId) {
        setTimeout(() => {
          this.scrollToTreeNode(widgetId)
        }, 100);
      }
    }
  }

  resetActiveElement(){
    if (this.activeElement) {
      this.activeElement.removeClass('active-tree-element');
      this.activeElement = null;
    }
  }

  buildTreeFromMarkup(markup: any, tree?: any, level?: number, parentWidgetId?: any) {
    let $children: any;

    if (!level) {
      $children = markup.children();
    } else {
      $children = markup.children;
    }

    let i, markupEl,
      widgetId,
      name,
      widgetType,
      canDelete,
      isContainer,
      treeEl,
      widgetConfig,
      hasChildren,
      isHtmlWidget,
      widgetSubType,
      isMovableInsideCanvas;

    isHtmlWidget = 'wm-html' === widgetType;

    level = level || 1;

    if ($children.length <= 0) {
      return;
    }
    let widgetTree: any = [];

    for (i = 0; i < $children.length; i++) {
      markupEl = $children[i];
      widgetId = markupEl?.getAttribute('widget-id') || markupEl?.getAttribute('widgetid');
      name = markupEl?.getAttribute('name');
      widgetType = markupEl.getAttribute('widgettype');
      hasChildren = markupEl.children.length;
      widgetSubType = markupEl.getAttribute('widget') || markupEl.getAttribute('type') || '';
      widgetSubType = widgetSubType.replace('wm-', '').toLowerCase();
      canDelete = markupEl.getAttribute('candelete');
      let isScaffold = !!this.widgetProperties.getConfig(widgetType)?.scaffold;

      // TODO: check if this is required or else remove the below code
      widgetConfig = widgetType ? this.widgetProperties.getConfig(widgetType) : {};
      /*in case of html widget, its inner elements also get included in the markup but for them widgetconfig is null */
      // if (widgetConfig) {
      //   isContainer = widgetConfig.isContainer;
      // }
      //
      isMovableInsideCanvas = widgetConfig?.isMovableInsideCanvas
      if (widgetId && !isScaffold) {
        treeEl = this.getTreeNode(widgetType, widgetId, name, isContainer, hasChildren, level, this.parentWidgetId, widgetSubType, isMovableInsideCanvas);
      }
      let innerChild = [];
      if (hasChildren && !isHtmlWidget) {
        innerChild = this.buildTreeFromMarkup(markupEl, tree, markupEl.getAttribute('scaffold') ? level : level + 1, markupEl.getAttribute('scaffold') ? parentWidgetId : widgetId);
      }
      if (innerChild && widgetId) {
        if (!isScaffold) {
          // @ts-ignore
          set(treeEl, 'children', innerChild);
          widgetTree.push(treeEl);
        } else {
          widgetTree.push(...innerChild);
        }
      }
    }
    return widgetTree;
  }

  getTreeNode(widgetType: string, widgetId: string, widgetName: string, isContainer: any, hasChildren:any, level: number, parentWidgetId: any, widgetSubType: any, isMovable: boolean) {
    let $node, $tmp, $i, $txt, icon;

    icon = widgetType.replace('wm-', '');

    if (widgetType === 'wm-chart') {
      icon = widgetSubType + icon;
    } else if (widgetType === 'wm-form-field' || widgetType === 'wm-filter-field') {
      icon = widgetSubType || 'text';
    }

    let childObj = {
      'id': widgetId + "--" + widgetName,
      'class': 'widget-icon wms wms-code-block wms-widget-' + icon,
      'props': {
        'name': widgetName,
        'type': widgetType,
        'widgetId': widgetId,
        'isMovable' :isMovable ?? true
      }
    }
    return childObj;
  }

  handleClick(nodeData: any) {
    this.selectedNode = nodeData;
    let widgetId: any = nodeData.dataItem.props.widgetId;
    if(this.activeTabName === 'MARKUP'){
       const widgetName = nodeData.dataItem.props.name
       this.selectWidget({widgetId: widgetId}, false);
       this.eventManager.emitTreeNodeChangeEvent(widgetName);
    }else{
      this.selectWidget({widgetId: widgetId}, true);
    }
  }

  selectWidget(obj: any, isTreeEvent?: boolean) {
    if (!obj.widgetId) {
      return;
    }
    let child = this.findElementByReference(obj.widgetId).tree?.eq(0);
    if(!(child?.attr('isExpanded'))){
      this.eventManager.emitExpandTreeNodeEvent(obj.widgetId);
      setTimeout(() => {
        this.focusTreeNode(obj, isTreeEvent)
      }, 100);
    }else{
        this.focusTreeNode(obj, isTreeEvent)
    }
  }

  focusTreeNode(obj: any, isTreeEvent?: boolean){
    let child = this.findElementByReference(obj.widgetId).tree?.eq(0);
     this.scrollToTreeNode(obj.widgetId)
    if (this.activeElement && this.activeElement.attr('widgetid') === child?.attr('widgetid')) {
      return;
    }

    if (this.activeElement) {
      this.selectedNode = {'id': this.activeElement.attr('data-id') || child?.attr('data-identifier')}
    }
    this.activeElement = child;
    this.selectedNode={'id': child?.attr('data-id') || child?.attr('data-identifier')}
    this.markupManager.setActiveTreeEl(this.activeElement);

    if (isTreeEvent) {
      obj.eventType = 'SELECT';
      obj.widgetId = child?.attr('widgetid');
      this.onTreeNodeSelect(obj);
    }
  }

  findElementByReference(reference: any) {
    let referenceElement,
      id = null,
      ele;
    if (!reference) {
      return {
        tree: null
      };
    }
    if (isString(reference)) {
      id = reference;
      ele = $('[widget-id=' + id + ']');
      let ele1 = $(reference).attr('widget-id');
      if (ele.attr('scaffold')) {
        ele = ele.closest('[widgetid]:not([scaffold])');
        id = ele.attr('widgetid');
      }
    } else {
      referenceElement = $(reference);
      if (!referenceElement.attr('scaffold')) {
        id = referenceElement.attr('widgetid');
        if (!id) {
          id = referenceElement.closest('[widgetid]').attr('widgetid');
        }
      } else {
        referenceElement.closest('[widgetid]:not([scaffold])');
        id = referenceElement.attr('widgetid');
      }
    }
    return {
      'tree': this.pageWsContent.find('[widgetid=' + id + ']')
    }

  }

  canvasUpdated(details:any){
    let obj:any = {};
    extend(obj,details);
    switch (obj.eventType) {
      case 'ADD':
      case 'DELETE':
      case 'MOVE':
        this.constructTree();
        break;
      case 'SELECT':
        this.selectWidget(obj);
        break;
      case 'ACTIVE':
        this.setActiveElement();
        break;
    }
  }

  //previous name canvasTreeUpdated
  onTreeNodeSelect(obj:any){
    switch (obj.eventType) {
      case "SELECT":
        this.eventManager.emitOnWidgetSelection(obj);
        break;
    }
  }

  onTreeDataChanged(nodeData:any){
    this.eventManager.emitOnwidgetRearrange(nodeData);
  }

  scrollToTreeNode(widgetId: string) {
    const treeContainer = document.querySelector('.treecontent-wrap') as HTMLElement;
    const node = document.querySelector(`[widgetid="${widgetId}"]`) as HTMLElement;
    if (!treeContainer || !node) return;
    this.pageStructureService.scrollElementIntoView(node, treeContainer);
  }

  ngOnDestroy() {
    runtimeEventManager.off('widget-name');
    this.registerDestroyListener.unsubscribe();
  }
}
